import React from "react";
import { NavLink } from "react-router-dom";

const HeaderButton = ({ dropdownItems }) => {
  return (
    <button className="bg-primary p-2 rounded-md group relative border-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="size-6 inline-block text-background ml-1"
      >
        <path
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
        />
      </svg>
      <span className="text-background text-base ml-2 hidden md:inline-block">حسابي الشخصي</span>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={3}
        stroke="currentColor"
        className="size-5 inline-block text-background "
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m19.5 8.25-7.5 7.5-7.5-7.5"
        />
      </svg>
      {dropdownItems.length > 0 && (
        <ul className="absolute w-max right-0 top-full lg:text-sm bg-white shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-20">
        {dropdownItems.map(({href, icon, label}, index) => (
          <li key={index} className="p-2 text-dark">
            <NavLink to={href} className="flex gap-2 hover:opacity-50 transition-all">
              {icon} {label}
            </NavLink>
          </li>
        ))}
      </ul>
      )}
    </button>
  );
};

export default HeaderButton;
